import { BffClaimResponse } from '@actiris/bff';
import { ApiOneResponse, one } from '@actiris/forms';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ContextResponse } from '@core/models/api/authentication/context-response';
import { LoginRequest } from '@core/models/api/authentication/login-request';
import { LoginResponse } from '@core/models/api/authentication/login-response';
import { LogoutResponse } from '@core/models/api/authentication/logout-response';
import { ProfileRequest } from '@core/models/api/authentication/profile-request';
import { ProfileResponse } from '@core/models/api/authentication/profile-response';
import { Language } from '@core/models/language';

import { map, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AuthenticationApiService {
    private http = inject(HttpClient);

    readonly baseUrl = '/api/authentication';

    context(returnUrl: string): Observable<ContextResponse> {
        return this.http
            .get<ApiOneResponse<ContextResponse>>(`${this.baseUrl}/context`, {
                params: returnUrl ? { ReturnUrl: returnUrl } : {},
            })
            .pipe(
                one(),
                map((context) => context ?? {}),
            );
    }

    profiles(request: ProfileRequest, language: Language): Observable<ProfileResponse> {
        return this.http.post<ApiOneResponse<ProfileResponse>>(`${this.baseUrl}/profiles/${language}`, request).pipe(one());
    }

    user(): Observable<BffClaimResponse[] | null> {
        return this.http.get<ApiOneResponse<BffClaimResponse[] | null>>(`${this.baseUrl}/user`).pipe(one());
    }

    login(request: LoginRequest): Observable<LoginResponse> {
        return this.http.post<ApiOneResponse<LoginResponse>>(`${this.baseUrl}/login`, request).pipe(one());
    }

    logoutInfo(logoutId: string): Observable<LogoutResponse> {
        return this.http
            .get<ApiOneResponse<LogoutResponse>>(`${this.baseUrl}/logout`, {
                params: { logoutId },
            })
            .pipe(one());
    }

    logout(logoutId: string | null): Observable<LogoutResponse> {
        return this.http.post<LogoutResponse>(`${this.baseUrl}/logout`, null, {
            params: logoutId ? { logoutId } : {},
        });
    }

    //UnUse for now but we are not sure that it wont be used in the futur

    // loginExtarnal(request: { email: string; code: string }): Observable<LoginResponse> {
    //     return this.http.put<LoginResponse>(`${this.baseUrl}/login-external`, request).pipe(one());
    // }
}
